import useUrlStateNumber from "@/hooks/useUrlStateNumber";

export interface SetValue {
  (value: boolean): void;
}

export default function useUrlStateBoolean(
  key: string,
  defaultValue?: boolean,
  replace?: boolean
): [boolean, SetValue] {
  const _defaultValue = defaultValue ? 1 : 0;
  const [numberValue, setNumberValue] = useUrlStateNumber(key, _defaultValue, replace);

  const setValue = (value: boolean) => {
    setNumberValue(value ? 1 : 0);
  };

  const value = !!numberValue;

  return [value, setValue];
}
